// src/components/ContactForm.jsx
import React, { useState } from 'react';
import { LEAD_ENDPOINT, FORMSPREE_ENDPOINT } from '../config/leads';

// utm_* parameters on the page URL travel with the enquiry so the CRM knows which campaign it came from
const readUtm = () => {
  const utm = {};
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (key.startsWith('utm_')) utm[key] = value;
  });
  return utm;
};

export default function ContactForm() {
  const [formStatus, setFormStatus] = useState('idle');
  const [formData, setFormData] = useState({ name:'', email:'', subject:'', message:'' });

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setFormStatus('submitting');
    try {
      const payload = LEAD_ENDPOINT
        ? { ...formData, source: 'contact-page', page: window.location.href, utm: readUtm() }
        : formData;
      const response = await fetch(LEAD_ENDPOINT || FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setFormStatus('success');
        setFormData({ name:'', email:'', subject:'', message:'' });
        setTimeout(()=>setFormStatus('idle'),3500);
      } else {
        setFormStatus('error');
        setTimeout(()=>setFormStatus('idle'),3500);
      }
    } catch {
      setFormStatus('error');
      setTimeout(()=>setFormStatus('idle'),3500);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="name" className="block text-lg font-bold mb-2">Name</label>
        <input
          type="text" id="name" name="name" required
          value={formData.name} onChange={handleInputChange}
          className="w-full px-4 py-2 bg-slate-900/50 border border-slate-600 rounded-lg text-white focus:ring-2 focus:ring-cyan-400 transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out)]-[border-color,box-shadow] duration-200 ease-[var(--ease-out)]"
          disabled={formStatus==='submitting'}
        />
      </div>
      <div>
        <label htmlFor="email" className="block text-lg font-bold mb-2">Email</label>
        <input
          type="email" id="email" name="email" required
          value={formData.email} onChange={handleInputChange}
          className="w-full px-4 py-2 bg-slate-900/50 border border-slate-600 rounded-lg text-white focus:ring-2 focus:ring-cyan-400 transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out)]"
          disabled={formStatus==='submitting'}
        />
      </div>
      <div>
        <label htmlFor="subject" className="block text-lg font-bold mb-2">Subject</label>
        <select
          id="subject" name="subject" required
          value={formData.subject} onChange={handleInputChange}
          className="w-full px-4 py-2 bg-slate-900/50 border border-slate-600 rounded-lg text-white focus:ring-2 focus:ring-cyan-400 transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out)]"
          disabled={formStatus==='submitting'}
        >
          <option value="">Select a topic...</option>
          <option value="ICE">ICE</option>
          <option value="GoingMerry">GoingMerry</option>
          <option value="Cortex">Cortex</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <div>
        <label htmlFor="message" className="block text-lg font-bold mb-2">Message</label>
        <textarea
          id="message" name="message" required rows={5}
          value={formData.message} onChange={handleInputChange}
          className="w-full px-4 py-2 bg-slate-900/50 border border-slate-600 rounded-lg text-white focus:ring-2 focus:ring-cyan-400 transition-[border-color,box-shadow] duration-200 ease-[var(--ease-out)]"
          disabled={formStatus==='submitting'}
        />
      </div>
      <button type="submit" disabled={formStatus==='submitting'}
        className={`px-8 py-3 rounded-full text-white font-bold text-lg hover-scale-press focus-visible-ring transition-[background-color,transform,box-shadow] duration-200 ease-[var(--ease-out)] ${
          formStatus==='submitting'
          ? 'bg-gray-600 cursor-not-allowed'
          : 'bg-gradient-to-r from-[#6FB6E8] to-[#62B7FF] hover:from-[#1E7FD1] hover:to-[#3DA3FF]'
        }`}>
        {formStatus==='submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {formStatus==='success' && (
        <div className="mt-2 px-6 py-3 bg-green-500/20 border border-green-500/50 rounded-lg text-green-400 text-center">
          ✓ Message sent successfully
        </div>
      )}
      {formStatus==='error' && (
        <div className="mt-2 px-6 py-3 bg-red-500/20 border border-red-500/50 rounded-lg text-red-400 text-center">
          ✗ Something went wrong. Please try again or email us directly at contact@dopove.com
        </div>
      )}
    </form>
  );
}
